import Image from 'next/image';
import { useMemo } from 'react';

import { getAddressScannerUrl, maskAddressValue } from '@/utils/format';

import { EventTriggerType, Trigger } from '../../domain';
import { TriggerExternalLinkDetail } from './components/TriggerExternalLinkDetail';
import { TriggerType } from './components/TriggerType';
import { TriggerValueDetail } from './components/TriggerValueDetail';

interface Props {
  trigger: Trigger;
  triggerType: EventTriggerType;
}

export const FelixVanillaCollateralTriggerDetails = ({ trigger, triggerType }: Props) => {
  const marketId = useMemo(() => {
    return trigger.context?.marketId || '';
  }, [trigger.context]);

  const assetAddress = useMemo(() => {
    return trigger.context?.asset || '';
  }, [trigger.context]);

  const chainId = useMemo(() => {
    return trigger.context?.chainId || 999;
  }, [trigger.context]);

  const scannerUrl = useMemo(() => {
    if (!assetAddress || !chainId) return '';
    return getAddressScannerUrl('chainId', chainId, assetAddress) ?? '';
  }, [assetAddress, chainId]);

  return (
    <div className="tw:flex tw:flex-row tw:gap-6">
      <TriggerType eventType={triggerType} />

      <TriggerValueDetail label="Market ID" value={maskAddressValue(marketId) ?? ''} />

      <TriggerExternalLinkDetail
        label="Asset"
        value={
          <div className="tw:flex tw:flex-row tw:gap-1 tw:items-center">
            <Image src="/assets/svg/hyperevm.svg" width={12} height={12} alt="HyperEVM" />
            <span>{maskAddressValue(assetAddress) ?? ''}</span>
          </div>
        }
        href={scannerUrl}
      />
    </div>
  );
};
